import axios from 'axios';
import apisUrls from '../urls';

const getAllInfluencersApi = (paramsFilter) => {
  return axios.get(apisUrls?.getInfluencers(paramsFilter));
};

export default getAllInfluencersApi;
